<form [formGroup]="form" *ngIf="form">
    <div class="form-group form-row">
        <div class="form-group col-lg-2 col-min" formGroupName="issueDate">
            <app-dc-date-input
                [readonly]="form.get('issueDate').readOnlyKeyDates"
                formControlName="value"
                label="Issue Date">
            </app-dc-date-input>
        </div>
        <div class="form-group col-lg-2 col-min" formGroupName="redemptionDate">
            <app-dc-date-input
                [readonly]="form.get('redemptionDate').readOnlyKeyDates"
                formControlName="value"
                label="Redemption Date">
            </app-dc-date-input>
        </div>
        <div *ngIf="productRequiresUnderlyingAsset" class="form-group col-lg-2 col-min" formGroupName="initialObservationDate">
            <app-dc-date-input
                [readonly]="form.get('initialObservationDate').readOnlyKeyDates"
                formControlName="value"
                label="Initial Obs. Date">
            </app-dc-date-input>
        </div>
        <div *ngIf="productRequiresUnderlyingAsset" class="form-group col-lg-2 col-min" formGroupName="finalObservationDate">
            <app-dc-date-input
                [readonly]="form.get('finalObservationDate').readOnlyKeyDates"
                formControlName="value"
                label="Final Obs. Date">
            </app-dc-date-input>
        </div>
        <ng-container *ngIf="productPaysCoupon()">
            <div class="form-group col-lg-2 col-min" formGroupName="interestStartDate">
                <app-dc-date-input
                    [readonly]="form.get('interestStartDate').readOnlyKeyDates"
                    formControlName="value"
                    label="Interest Start Date">
                </app-dc-date-input>
            </div>
            <div class="form-group col-lg-2 col-min" formGroupName="interestEndDate">
                <app-dc-date-input
                    [readonly]="form.get('interestEndDate').readOnlyKeyDates"
                    formControlName="value"
                    label="Interest End Date">
                </app-dc-date-input>
            </div>
        </ng-container>
    </div>
</form>